import React, { Component } from 'react';
import Storage from '../../../services/local-store';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import moment from 'moment';
import { Tooltip, Spin, Modal, Tabs, Empty } from 'antd';
import Counselling_upload from '../newCounsellingForms/uploadDocument';
import New_Counselling_upload from '../newCounsellingForms/newFileUploadDocuments.js';
const { getPatientHistory, homepage } = networkList;

const { TabPane } = Tabs;

class Patient_history extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadding: false,
            addnoteModal: false,
            addnote: [],
            resData: [{
                "counsellings": []
            }],
            patientData: [],
            thead: [
                {
                    "key": 'patient_name',
                    'text': 'patient name'
                }, {
                    "key": 'umr',
                    'text': 'UMR'
                }, {
                    "key": 'phone_number',
                    'text': 'phone number'
                }, {
                    "key": 'age',
                    'text': 'age',
                }, {
                    "key": 'gender',
                    'text': 'gender'
                }, {
                    "key": 'unit_name',
                    'text': 'unit name'
                }
            ],
            card1: [
                {
                    "key": 'date_of_counselling',
                    'text': 'date of counselling'
                }, {
                    "key": 'umr_no',
                    'text': 'UMR'
                }, {
                    "key": 'unit_name',
                    'text': 'unit name'
                }, {
                    "key": 'total_estimate_amt',
                    'text': 'total estimate amount',
                }, {
                    "key": 'counselled_by',
                    'text': 'counselled by'
                }, {
                    "key": 'privilege_name',
                    'text': 'privilege name'
                }, {
                    "key": 'payment_type',
                    'text': 'payment type'
                }
            ],
            card2: [
                {
                    "key": 'date_of_counselling',
                    'text': 'date of counselling'
                }, {
                    "key": 'admission_date',
                    'text': 'admission date'
                }, {
                    "key": 'total_estimate_amt',
                    'text': 'total estimate amount',
                }, 
                // {
                //     "key": 'discharge_date',
                //     'text': 'discharge date'
                // }, 
                {
                    "key": 'counselled_by',
                    'text': 'counselled by'
                }, {
                    "key": 'privilege_name',
                    'text': 'privilege name'
                }, {
                    "key": 'payment_type',
                    'text': 'payment type'
                }
            ], card3: [
                {
                    "key": 'umr_no',
                    'text': 'UMR'
                }, {
                    "key": 'ip_no',
                    'text': 'IP'
                }, {
                    "key": 'unit_name',
                    'text': 'unit name'
                },{
                    "key": 'discharge_date',
                    'text': 'discharge date'
                }
            ],
        }
    }

    componentDidMount() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        const params = new URLSearchParams(this.props.location.search);
        const umr_no = params.get('umr');
        const unit_id = params.get('unit_id');
        if (umr_no && unit_id) {
            this.fetchListData(umr_no, unit_id);
        } else {
            this.props.history.push(`/patients`);
            Modal.error({
                content: 'Unable to Fetch Data'
            });
        }
    }

    fetchListData(umr_no, unit_id) {
        this.setState({ loadding: true })
        let payload = {
            "unit_id": unit_id,
            "umr_no": umr_no
        }
        postService(getPatientHistory, 'POST', { 'data': payload }).then(res => {
            if (res.status === true) {
                this.setState({ 'resData': res.data, loadding: false });
            } else {
                this.setState({ loadding: false });
                Modal.error({
                    content: res.message ? res.message : 'Unable to Fetch Data'
                });
            }
        })
    }

    navigateTo(data) {
        let {counselling_id, ip_no, privilige_id, FC_PRIVILEGE_IDS, umr_no, unit_id,payment_type,payment_type_id,form_type}= data
        let id = counselling_id
        let ip = ip_no
        let umr = umr_no
        let unit = unit_id 
        let payment = null 
        if(payment_type){
            if(payment_type === 'Cash'){
                payment = '1'
            }else if(payment_type === 'Insurance'){
                payment = '2'
            }else if(payment_type === 'Corporate'){
                payment = '3'
            }
        }
        console.log('yes',data)
        window.open(`${homepage}/counselling/view-finanical-counselling?pid=${payment_type_id}&cid=${counselling_id}&fid=${form_type}`, '_blank', 'noopener,noreferrer');
        // data['counselling_id'], data['ip_no'], data['privilige_id'],data['FC_PRIVILEGE_IDS']
        // let { previlege_data } = this.state;
        // if (FC_PRIVILEGE_IDS.includes(privilige_id)) {
        //     // if (id !== undefined && id !== null && id !== '') {
        //     //     http://103.99.110.8:3001/counselling/counselling-print?token_data=46129
        //     //     this.props
        //     //         .history
        //     //         .push(`/counselling/view-finanical-counselling?rid=${id}&umr=${umr}&unit_id=${unit}`);
        //     // } else {
        //     //     this.props
        //     //         .history
        //     //         .push(`/counselling/view-finanical-counselling?rid=${id}&ip=${ip}&umr=${umr}&unit_id=${unit}`);
        //     // }
        //     if (id !== undefined && id !== null && id !== '') {
        //         this.props
        //             .history
        //             .push(`/counselling/counselling-print?token_data=${id}&payment_type=${payment}&umr=${umr}&unit_id=${unit}&nav_from=patients-history`);
        //     } else {
        //         this.props
        //             .history
        //             .push(`/counselling/counselling-print?token_data=${id}&payment_type=${payment}&umr=${umr}&unit_id=${unit}&nav_from=patients-history`);
        //     }
        // }else{
        //     if (id !== undefined && id !== null && id !== '') {
        //         this.props
        //             .history
        //             .push(`/counselling/view-other-counselling?rid=${id}&umr=${umr}&unit_id=${unit}&nav_from=patients-history`);
        //     } else {
        //         this.props
        //             .history
        //             .push(`/counselling/view-other-counselling?rid=${id}&ip=${ip}&umr=${umr}&unit_id=${unit}&nav_from=patients-history`);
        //     }
        // }

    }

openupload=(data)=>{
    let {unit_id,umr_no,ip_no,counselling_id,date_of_counselling}=data
    let{resData}=this.state
    let sendData= {
        'unit_id':unit_id,
        'umr_no':umr_no,
        'ip_no':ip_no,
        'patient_name': resData[0].patient_name,
        'temp': Math.floor(Math.random() * 100),
        'counselling_id':counselling_id,
        'date_of_counselling':date_of_counselling
    }
    this.setState(()=>({'mydata': sendData}),()=>{this.child.setModal1Visible(true)});
    
}
    render() {
        const { resData, thead, loadding, card1, card2, card3 } = this.state;
        let counsellings = resData[0]['counsellings']
        console.log(resData);
        return (
            <Spin spinning={loadding}>
                <div className="mt-2 todolist">
                    <div className="card m-5">
                        <div className="row p-5">
                            {thead.map((tHdata, tHkey) => {
                                return (<div className="col-xl-4 col-lg-4 col-sm-6 d-flex" key={tHkey}>
                                    <p className="data-label">{tHdata['text']}</p>
                                    <p className="data-item">: {(resData[0][tHdata['key']] && resData[0][tHdata['key']] !== null) ? resData[0][tHdata['key']] : '--'}</p>
                                </div>)
                            })}
                        </div>
                    </div>
                    <div class="pr-5">
                        {(resData && resData.length !== 0) && <React.Fragment>
                            <div class="item">
                                <div id="timeline" style={{ width: '98%' }}>
                                    <span>
                                        {counsellings.map((item, tkey) => {
                                            let admissions = item['admissions']
                                            return (
                                                <section class="year">
                                                    {/* <h3>{moment(item.date_of_counselling).format('DD-MMM-YYYY')}</h3>
                                                    <h5>{moment(item.date_of_counselling).format('HH:mm')}</h5> */}
                                                    { item['admissions'].length > 0 &&
                                                        <section>
                                                            <ul>
                                                                <div className={item['admissions'].length > 0 ? "tborder" : "card shadow-none d-flex flex-row"} >
                                                                    <div className="row ml-0 mr-0 pt-0 pb-3">
                                                                        {card3.map((data, tHkey) => {
                                                                            if (data['key'] == 'discharge_date') {
                                                                                return (
                                                                                    <div className="col-3 pt-3 pl-3 text-capitalize" key={tHkey}>
                                                                                        <p className="data-label">{data['text']}</p>
                                                                                        <p className="data-item">{item[data['key']] ? moment(item[data['key']]).format('DD-MM-YYYY HH:mm') : '--'}</p>
                                                                                    </div>)
                                                                            }
                                                                            return (
                                                                                <div className="col-3 pt-3 pl-3 text-capitalize" key={tHkey}>
                                                                                    <p className="data-label">{data['text']}</p>
                                                                                    <p className="data-item">{item[data['key']] ? item[data['key']] : '--'}</p>
                                                                                </div>)
                                                                        })}
                                                                    </div>
                                                                    {/* <div className="my-auto">Counselling_upload</div> */}
                                                                    {item['admissions'].map((item2, index) => {
                                                                        return (<div className="card shadow-none mx-3 mb-3"><div className="row ml-0 mr-0 pt-0 pb-3">
                                                                            {card2.map((data, tHkey) => {
                                                                                if (data['key'] == 'date_of_counselling') {
                                                                                    return (
                                                                                        <React.Fragment>
                                                                                            <div className="col-4 pt-3 pl-3 text-capitalize" key={tHkey}>
                                                                                            <p className="data-label">{data['text']}</p>
                                                                                            <p className="data-item">{item2[data['key']] ? moment(item2[data['key']]).format('DD-MM-YYYY HH:mm') : '--'}</p>
                                                                                        </div>
                                                                                        <div className="position-absolute" style={{right: '10px',zIndex: 1}}>
                                                                                        <Tooltip title="View Details"><img src={homepage+"/assets/images/view-border.png"} alt="view" className="mt-2" onClick={this.navigateTo.bind(this, item2)} /></Tooltip>                                                                                
                                                                                        <Tooltip title="Upload Documents"><img src={homepage+"/assets/images/upload.png"} alt="edit" className="mt-2" onClick={()=>{this.openupload(item2)}} /></Tooltip>                                                                                
                                                                                        {/* <Counselling_upload {...this.props} {...this.state} ref={instance => { this.child = instance; }} /> */}
                                                                                        <New_Counselling_upload {...this.props} {...this.state} ref={instance => { this.child = instance; }}/>
                                                                                        </div>
                                                                                        </React.Fragment>)
                                                                                }
                                                                                if (data['key'] == 'discharge_date' || data['key'] == 'admission_date') {
                                                                                    return (
                                                                                        <div className="col-4 pt-3 pl-3 text-capitalize" key={tHkey}>
                                                                                            <p className="data-label">{data['text']}</p>
                                                                                            <p className="data-item">{item[data['key']] ? moment(item[data['key']]).format('DD-MM-YYYY HH:mm') : '--'}</p>
                                                                                        </div>)
                                                                                }
                                                                                return (
                                                                                    <div className="col-4 pt-3 pl-3 text-capitalize" key={tHkey}>
                                                                                        <p className="data-label">{data['text']}</p>
                                                                                        <p className="data-item">{item2[data['key']] ? item2[data['key']] : '--'}</p>
                                                                                    </div>)
                                                                            })}
                                                                        </div>
                                                                        </div>)
                                                                    })}
                                                                </div>

                                                            </ul>
                                                        </section>
                                                    }
                                                    {item['admissions'].length == 0 &&
                                                        <section>
                                                            <ul>
                                                                <div className={item['admissions'].length > 0 ? "tborder" : "card shadow-none d-flex flex-row"}>
                                                                    <div className="row ml-0 mr-0 pt-0 pb-3">
                                                                        {card1.map((data, tHkey) => {
                                                                            if (data['key'] == 'date_of_counselling') {
                                                                                return (<React.Fragment>        
                                                                                    <div className="col-4 pt-3 pl-3 text-capitalize" key={tHkey}>
                                                                                        <p className="data-label">{data['text']}</p>
                                                                                        <p className="data-item">{item[data['key']] ? moment(item[data['key']]).format('DD-MM-YYYY HH:mm') : '--'}</p>
                                                                                    </div>
                                                                                    
                                                                                <div className="position-absolute" style={{right: '10px',zIndex: 1}}>
                                                                                <Tooltip title="View Details"><img src={homepage+"/assets/images/view-border.png"} alt="view" className="mt-2" onClick={this.navigateTo.bind(this, item)} /></Tooltip>                                                                                
                                                                                <Tooltip title="Upload Documents"><img src={homepage+"/assets/images/upload.png"} alt="edit" className="mt-2" onClick={()=>{this.openupload(item)}} /></Tooltip>                                                                                
                                                                                {/* <Counselling_upload {...this.props} {...this.state} ref={instance => { this.child = instance; }} /> */}
                                                                                <New_Counselling_upload {...this.props} {...this.state} ref={instance => { this.child = instance; }}/>
                                                                                </div>
                                                                            </React.Fragment>)
                                                                            }
                                                                            if (data['key'] == 'discharge_date' || data['key'] == 'admission_date') {
                                                                                return (
                                                                                    <div className="col-4 pt-3 pl-3 text-capitalize" key={tHkey}>
                                                                                        <p className="data-label">{data['text']}</p>
                                                                                        <p className="data-item">{item[data['key']] ? moment(item[data['key']]).format('DD-MM-YYYY HH:mm') : '--'}</p>
                                                                                    </div>)
                                                                            }
                                                                            return (                                                                        
                                                                                <div className="col-4 pt-3 pl-3 text-capitalize" key={tHkey}>
                                                                                    <p className="data-label">{data['text']}</p>
                                                                                    <p className="data-item">{item[data['key']] ? item[data['key']] : '--'}</p>
                                                                                </div>
                                                                                )
                                                                        })}
                                                                    </div>
                                                                </div>

                                                            </ul>
                                                        </section>

                                                    }
                                                </section>
                                            )
                                        }
                                        )}
                                    </span>
                                </div>
                            </div>
                        </React.Fragment>}
                        {resData && counsellings.length === 0 &&
                            <React.Fragment>
                                <div className="row ml-0 mr-0 pt-0 pb-3">
                                    <div className="col-12 mx-2 my-5">
                                        <Empty description={<span>No history is available for this patient.</span> } />
                                    </div>
                                </div>
                            </React.Fragment>
                        }
                        <div className="row mb-5">
                            <button className="btn btn-next text mx-auto" onClick={() => { this.props.history.push(`/patients/patients-history`) }}>Back</button>
                        </div>
                    </div>
                </div>
            </Spin>
        )
    }
}

export default Patient_history;